/** Hauteur approximative de la navbar fixe (px). */
const NAVBAR_OFFSET = 72;

/**
 * Scroll vers une ancre de la landing, avec retries si le DOM n'est pas encore monté
 * (navigation depuis une autre route, PersistGate, etc.).
 */
export function scrollToSection(sectionId: string, maxAttempts = 40): void {
  const doScroll = (): boolean => {
    const el = document.getElementById(sectionId);
    if (!el) return false;

    const top =
      el.getBoundingClientRect().top + window.pageYOffset - NAVBAR_OFFSET;
    window.scrollTo({ top: Math.max(0, top), behavior: "smooth" });
    return true;
  };

  if (doScroll()) return;

  let attempts = 0;
  const timer = window.setInterval(() => {
    attempts += 1;
    if (doScroll() || attempts >= maxAttempts) {
      window.clearInterval(timer);
    }
  }, 100);
}
